//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderBy } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InterstitialNavbar",
  props: {
    tiedBrokerages: {
      type: Array,
      required: true
    },
    selectedBrokerage: {
      type: null,
      required: true
    },
    lastBrokerNameByBrokerage: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderedTiedBrokerages() {
      return orderBy(this.tiedBrokerages, "brokerageId", "asc");
    }
  },
  methods: {
    navigateToBrokerage(brokerageId) {
      this.$emit("update:selectedBrokerage", brokerageId);
    }
  }
});